/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AITranslationGlossaryEntryRequestDto } from '../models/AITranslationGlossaryEntryRequestDto';
import type { AITranslationGlossaryEntryResponseDto } from '../models/AITranslationGlossaryEntryResponseDto';
import type { AITranslationSettingsResponseDto } from '../models/AITranslationSettingsResponseDto';
import type { ToggleStateRequestDto } from '../models/ToggleStateRequestDto';
import type { TypoFrequencyRequestDto } from '../models/TypoFrequencyRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApiForAiSettingsService {
    /**
     * Enable using glossary for creator
     * @returns void
     * @throws ApiError
     */
    public static setUseGlossary({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/use-glossary',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Set typo frequency for creator
     * @returns void
     * @throws ApiError
     */
    public static setTypoFrequency({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: TypoFrequencyRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/typo-frequency',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Set remove question mark for creator
     * @returns void
     * @throws ApiError
     */
    public static setRemoveQuestionMark({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/remove-question-mark',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Set remove points for creator
     * @returns void
     * @throws ApiError
     */
    public static setRemovePoints({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/remove-points',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Set remove exclamation mark for creator
     * @returns void
     * @throws ApiError
     */
    public static setRemoveExclamationMark({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/remove-exclamation-mark',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Set remove commas for creator
     * @returns void
     * @throws ApiError
     */
    public static setRemoveCommas({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/remove-commas',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Set remove apostrophes for creator
     * @returns void
     * @throws ApiError
     */
    public static setRemoveApostrophes({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/remove-apostrophes',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Enable typo generation for creator
     * @returns void
     * @throws ApiError
     */
    public static setIntroduceTypos({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/introduce-typos',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Get glossary entries for creator
     * @returns AITranslationGlossaryEntryResponseDto Get page of glossary entries for creator
     * @throws ApiError
     */
    public static getGlossaryEntries({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<Array<AITranslationGlossaryEntryResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/glossary',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Add glossary entry for creator
     * @returns AITranslationGlossaryEntryResponseDto Successfully add glossary entry
     * @throws ApiError
     */
    public static addGlossaryEntry({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: AITranslationGlossaryEntryRequestDto,
    }): CancelablePromise<AITranslationGlossaryEntryResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/glossary',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
                409: `Glossary entry already exists`,
            },
        });
    }
    /**
     * Set generate emoji for creator
     * @returns void
     * @throws ApiError
     */
    public static setGenerateEmoji({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/generate-emoji',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Set convert to lower case for creator
     * @returns void
     * @throws ApiError
     */
    public static setConvertToLowerCase({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ToggleStateRequestDto,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/convert-to-lower-case',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Get ai translation settings for creator
     * @returns AITranslationSettingsResponseDto Get ai translation settings for creator
     * @throws ApiError
     */
    public static getAiTranslationSettings({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<AITranslationSettingsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
            errors: {
                403: `Invalid creator`,
            },
        });
    }
    /**
     * Remove glossary entry for creator
     * @returns void
     * @throws ApiError
     */
    public static removeGlossaryEntry({
        creatorId,
        glossaryId,
    }: {
        creatorId: number,
        glossaryId: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/ai-translation-settings/{creatorId}/glossary/{glossaryId}',
            path: {
                'creatorId': creatorId,
                'glossaryId': glossaryId,
            },
            errors: {
                403: `Invalid creator`,
            },
        });
    }
}
